import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PodcastCard } from "@/components/PodcastCard";
import { SEO } from "@/components/SEO";
import { NewsletterModal } from "@/components/NewsletterModal";
import { Button } from "@/components/ui/button";

export default function PodcastsPage() {
  const [episodes, setEpisodes] = useState([]);
  const [newsletterOpen, setNewsletterOpen] = useState(false);

  useEffect(() => {
    api.get("/podcasts", { params: { limit: 40 } }).then(({ data }) => setEpisodes(data.items));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="podcasts-page">
      <SEO title="Подкаст" description="Живот и Имоти — подкаст на Investivo за инвестиции в недвижими имоти." />
      <div className="bg-[#10243A] text-white px-8 py-12 mb-12 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#C47A35]">Metri.bg Podcast</span>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold mt-2">Живот и Имоти</h1>
          <p className="mt-3 text-[#C8D3DC] max-w-xl">Разговори за инвестиции в имоти, пазарни стратегии и живота на инвеститора — от YouTube канала на Investivo.</p>
        </div>
        <Button onClick={() => setNewsletterOpen(true)} className="bg-[#C47A35] hover:bg-white hover:text-[#10243A] rounded-none transition-colors" data-testid="podcast-newsletter-trigger">
          Абонирай се за нови епизоди
        </Button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="podcasts-grid">
        {episodes.map((e) => <PodcastCard key={e.id} episode={e} />)}
      </div>
      {episodes.length === 0 && <p className="text-[#66717B]">Все още няма публикувани епизоди.</p>}
      <NewsletterModal open={newsletterOpen} onOpenChange={setNewsletterOpen} source="podcast" />
    </div>
  );
}
